import { render, staticRenderFns } from "./ProviderConnectionCard.vue?vue&type=template&id=119fff27&scoped=true&"
import script from "./ProviderConnectionCard.vue?vue&type=script&lang=js&"
export * from "./ProviderConnectionCard.vue?vue&type=script&lang=js&"
import style0 from "./ProviderConnectionCard.vue?vue&type=style&index=0&id=119fff27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119fff27",
  null
  
)

export default component.exports